import { render, staticRenderFns } from "./ChangeCourses.vue?vue&type=template&id=4ac995f8"
import script from "./ChangeCourses.vue?vue&type=script&lang=js"
export * from "./ChangeCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports